exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".avm-btn[data-v-de304fc2]{background-color:#00adbc!important;text-transform:unset}.avm-error>.flex[data-v-de304fc2]{max-width:75vw}", ""]);

// exports
